import store from "../../../store";
import { googleSnippet, facebookSnippet } from "./constants";

/**
 * Verificar si estamos en presencia de cierto CID en la URL para disparar el pixel
 * (o una callback en general)
 * @param cid Array | String
 * @param cb function
 */
const matchesTCode = (cid, cb) => {
  let current_cid = store.getters.getTcode();
  // El cid puede ser string o array
  if (typeof cid === "string") {
    cid = [cid];
  }

  for (let c of cid) {
    if (
      current_cid &&
      (current_cid + "").toLowerCase().includes(c.toLowerCase())
    ) {
      if (cb && typeof cb == "function") {
        return cb();
      }
    }
  }
};

const googlePX = step => {
  const pxCircuit = _BBVA_MOTOR || "ofertaPersonales";
  const googleReturn = googleSnippet[pxCircuit][step];

  if (googleReturn) return googleReturn;
  return false;
};

const facebookPX = step => {
  const pxCircuit = _BBVA_MOTOR || "ofertaPersonales";
  let method = facebookSnippet[pxCircuit][step][0];
  let event = facebookSnippet[pxCircuit][step][1];
  let fbkContentTypeReturn = facebookSnippet[pxCircuit][step][2];
  let fbkContentNameReturn = facebookSnippet[pxCircuit][step][3];
  let content;

  content = fbkContentNameReturn
    ? { content_type: fbkContentTypeReturn, content_name: fbkContentNameReturn }
    : { content_type: fbkContentTypeReturn };

  return { method, event, content };
};

export { matchesTCode, googlePX, facebookPX };
